import axios from '@/axios/api.request'

export const statis = (params) => axios.request({
    url: '/statis/target',
    data: params,
    method: 'post'
  })
